import { Tabs, TabOption, TabsProps } from 'components/UI';
import { ConfiguratorTab } from 'constants/configurator';

type SideMenuTabOption = TabOption & {
  id: ConfiguratorTab;
};

type SideMenuTabsProps = TabsProps & {
  options: SideMenuTabOption[];
  currentTab: ConfiguratorTab;
  onChangeTab(tab: ConfiguratorTab): void;
};

const SideMenuTabs = ({ currentTab, options, onChangeTab, panelProps }: SideMenuTabsProps) => {
  const menuIndexNameMap = options.reduce((acc, { id }: SideMenuTabOption, i) => acc.set(i, id), new Map());

  const menuNameIndexMap = options.reduce((acc, { id }: SideMenuTabOption, i) => acc.set(id, i), new Map());

  return (
    <Tabs
      index={menuNameIndexMap.get(currentTab)}
      onChange={(index: number) => onChangeTab(menuIndexNameMap.get(index))}
      orientation="vertical"
      variant="unstyled"
      tabListProps={{
        bg: 'linear-gradient(178deg,var(--chakra-colors-base1Colour-400) 0%,var(--chakra-colors-base1Colour-400) 40%,var(--chakra-colors-base1Colour-500) 500%)',
      }}
      panelProps={{
        p: 0,
        bgColor: 'base2Colour.400',
        h: 'calc(100vh - 82px)',
        ...panelProps,
      }}
      tabProps={{
        _hover: {
          bg: 'base1Colour.500',
          color: 'secondaryThemeColour.400',
          opacity: 0.4,
          _disabled: {
            bg: 'base1Colour.500',
            opacity: 1,
            color: 'secondaryThemeColour.400',
            _hover: {
              bg: 'base1Colour.500',
            },
          },
        },
        _disabled: {
          cursor: 'pointer',
          bg: 'base1Colour.500',
          opacity: 1,
          color: 'secondaryThemeColour.400',
        },
        _focus: {
          boxShadow: 'none',
        },
        color: 'primaryFontColour.500',
        borderStyle: 'solid',
        borderRadius: 0,
        w: 'full',
        bg: 'transparent',
        py: 3,
        px: 6,
        h: 'auto',
        display: 'inline-block',
        _selected: {
          color: 'secondaryThemeColour.400',
          bg: 'base1Colour.500',
          _hover: {
            opacity: 1,
          },
        },
      }}
      options={options}
    />
  );
};

export default SideMenuTabs;
